import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { updateConfig } from "../../../../store/slices/Recheck/recheckSlice";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { uploadExcelFiles } from "../api";
import { useState } from "react";

const useExcelUpload = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const reAssignState = useSelector((state) => state.recheck);
  const initialValues = {
    excel_file: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: "",
    onSubmit: async (values) => {
      setLoading(true);
      let newObj = Object.entries(values);
      newObj = newObj
        .filter(
          (item) => item[1] !== undefined && item[1] !== "" && item[1] !== null,
        )
        .reduce((a, v) => ({ ...a, [v[0]]: v[1] }), {});

      const formData = new FormData();
      Object.keys(newObj).forEach((key) => {
        formData.append(key, values[key]);
      });
      formData.append("receipt_id", reAssignState?.selectedId[0]);
      try {
        const response = await uploadExcelFiles(formData);
        if (response?.data?.status_code === 200) {
          setLoading(false);
          toast.success("Excel file uploaded successfully");
          dispatch(
            updateConfig((state) => {
              state.excelUploadModal = false;
            }),
          );
        } else if (response?.status_code === 422 && response?.errors) {
          setLoading(false);
          Object.keys(response?.errors).forEach((field) => {
            formik.setFieldError(field, response?.errors[field]);
          });
        } else {
          setLoading(false);
          toast.error("Unable to upload file, Please try again");
        }
      } catch (error) {
        setLoading(false);
        console.error("Unable to upload file:, error");
      }
    },
  });
  const handleClose = () => {
    dispatch(
      updateConfig((state) => {
        state.excelUploadModal = false;
      }),
    );
  };

  const handleExcelUpload = async (e) => {
    const selectedFile = e?.target?.files?.[0];
    const fileTypes = [
      ".csv",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    if (selectedFile) {
      if (fileTypes?.includes(selectedFile?.type)) {
        if (selectedFile?.size <= 2 * 1024 * 1024) {
          formik?.setFieldValue("excel_file", e?.target?.files?.[0]);
        } else {
          formik?.setFieldError(
            "excel_file",
            "File size should be less than 2MB",
          );
        }
      } else {
        formik?.setFieldError("excel_file", "Invalid file type");
      }
    }
  };
  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };
  return {
    loading,
    formik,
    handleClose,
    handleExcelUpload,
    getFieldError,
  };
};

export default useExcelUpload;
